<template>
	<div :class="['note-item flex flex-col justify-between cursor-pointer', {'is-active': isActive}]" @click="() => $emit('click', value)">
		<div class="header flex items-center">
			<div v-if="value.color" class="color rounded-full w-5 h-5" :style="{backgroundColor: value.color}"></div>
			<div class="ml-3 title text-black font-medium truncate">
				<span v-if="value.title">{{ value.title }}</span>
				<span v-else>{{ noTitleText }}</span>
			</div>
		</div>

		<div class="content" v-html="value.excerpt "></div>

		<div class="footer flex justify-between items-center">
			<div class="date-info text-gray-3">{{ value.date | dateTime(userDateTimeFormat) }}</div>
			<i
				v-if="isRemoveable"
				class="nucleo nucleo-trash-can cursor-pointer font-bold"
				@click.stop="$emit('onRemove', value)"
			></i>
		</div>
	</div>
</template>

<script>
import _ from "lodash";

export default {
	name: "NoteItem",
	props: {
		value: {
			type: Object,
			validator: prop =>
				_.has(prop, "date") &&
				_.has(prop, "color") &&
				_.has(prop, "title") &&
				_.has(prop, "excerpt")
		},
		isActive: {
			type: Boolean,
			default: false
		},
		isRemoveable: {
			type: Boolean,
			default: true
		},
		noTitleText: {
			type: String,
			default: "No title"
		}
	},
	emits: {
		onRemove: {}
	}
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/cbs/_mixins.scss";

.note-item {
	height: 117px;
	padding: 16px;
	border: 1px solid var(--color-gray-5);

	&.is-active {
		border: 2px solid var(--color-solid-primary);
	}

	.header {
		.color {
			min-width: 1.25rem;
		}

		.title {
			font-size: 16px;
		}
	}

	.content {
		overflow: hidden;
	}

	.footer .date-info {
		font-size: 12px;
	}
}
</style>
